import { DETAIL_BY_OPTIONS } from '../../constant';
import type { ExcelColumnMapping } from './types';
import { roundNumber } from '@/lib/formatUtils';

const getDetailLabel = (detailBy?: number) => DETAIL_BY_OPTIONS.find(option => option.value === detailBy)?.label ?? '';

export const getBaoCaoMuaHangNhomTheoHaiChiTieuColumns = (detailBy?: number): ExcelColumnMapping[] => {
  const detailLabel = getDetailLabel(detailBy);
  const nameSuffix = detailLabel ? ` ${detailLabel}` : '';

  return [
    { header: `Mã${nameSuffix}`, resolver: row => row.ma ?? '' },
    { header: `Tên${nameSuffix}`, resolver: row => row.ten ?? '' },
    { header: 'Số lượng', resolver: row => roundNumber(Number(row.sl_nhap ?? 0)) },
    { header: 'Giá', resolver: row => roundNumber(Number(row.gia ?? 0)) },
    { header: 'Tiền', resolver: row => roundNumber(Number(row.tien_nhap ?? 0)) },
    { header: 'Thuế', resolver: row => roundNumber(Number(row.thue ?? 0)) },
    { header: 'Chi phí', resolver: row => roundNumber(Number(row.cp ?? 0)) }
  ];
};

export const BAO_CAO_MUA_HANG_NHOM_THEO_HAI_CHI_TIEU_COLUMNS = getBaoCaoMuaHangNhomTheoHaiChiTieuColumns();
